import { useCallback, useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';

function useConfirmAfterLogin(): (onContinue: () => void) => () => void {
  const { setConfirmModalOpen } = useContext(ModalContext);

  return useCallback(
    (onContinue: () => void) => () => {
      // Note: we can't depend on state being up-to-date here, so we don't check
      // it before showing the modal. If this hook's function is called we
      // assume the caller knows what it's doing.
      setConfirmModalOpen(true, {
        onContinue: () => {
          setConfirmModalOpen(false);
          onContinue();
        },
        onlyConfirmCancellation: true
      });
    },
    [setConfirmModalOpen]
  );
}

export default useConfirmAfterLogin;
